module.exports = __webpack_public_path__ + "assets/img/03.88535c77.png";